import NotificationAlert from "react-notification-alert";
import MaterialReactTable from "material-react-table";
import { t } from 'react-multi-lang';
import { MRT_Localization_FR } from "material-react-table/locales/fr";
import { MRT_Localization_EN } from "material-react-table/locales/en";
import { Button, Card, Container, Row, Col } from "react-bootstrap";
import React, { useEffect, useCallback, useState } from "react";
import { fetchLigneIms, ligneChangerEtat } from "../../../Redux/ligneImsReduce";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

// core components
function ListLigneIms({client}) {
  document.title = "Liste des lignes";
  const dispatch = useDispatch();
  const navigate = useHistory();
  let lang = window.localStorage.getItem("lang");
  const notificationAlertRef = React.useRef(null);
  const [entities, setEntities] = React.useState([]);
  const [loader, setLoader] = React.useState(true);
  const notify = (place, msg, type) => {
    var options = {};
    options = {
      place: place,
      message: (
        <div>
          <div>
            {msg}
          </div>
        </div>
      ),
      type: type,
      icon: "nc-icon nc-bell-55",
      autoDismiss: 7,
    };
    notificationAlertRef.current.notificationAlert(options);
  };
  function ajouter() {
    navigate.push(client+'/ajouterLigneIms');
  }
  function changeEtat(id, e) {
    dispatch(ligneChangerEtat(id)).then(e1 => {
      getLigne();
      switch (e) {
        case 0: notify("tr", "Ligne Ims activé avec succes", "success"); break;
        case 1: notify("tr", "Ligne Ims désactivé avec succes", "success"); break;
        default: break;
      }
    });
  }

  const [columns] = useState([
    {
      header: "Nom",
      accessorKey: "nom",
    },
    {
      header: "Etat",
      accessorKey: "etat",
      Cell: ({ cell }) => (cell.row.original.etat === 1 ? "Activé" : "Désactivé"),
    },
    {
      header: "actions",
      accessorKey: "id",
      Cell: ({ cell }) => (
        <div className="actions-right block_action">
          <Button
            onClick={() => {
              navigate.push(client+"/ligne/update/" + cell.row.original.id);
            }}
            variant="warning"
            size="sm"
            className="text-warning btn-link edit"
          >
            <i className="fa fa-edit" />
          </Button>
          <Button
            id={"idLigne_" + cell.row.original.id}
            onClick={(event) => {
              changeEtat(cell.row.original.id, cell.row.original.etat);
            }}
            variant="danger"
            size="sm"
            className={cell.row.original.etat === 1 ? "text-success btn-link delete" : "text-danger btn-link delete"}
          >
            <i className={cell.row.original.etat === 1 ? "fa fa-check" : "fa fa-times"} id={"idLigne_" + cell.row.original.id} />
          </Button>
        </div>
      ),
    },
  ])

  const getLigne = useCallback(async (titre) => {
    var ligne = await dispatch(fetchLigneIms());
    setEntities(ligne.payload);
    setLoader(false)
  }, [dispatch]);
  useEffect(() => {
    getLigne()
  }, [getLigne]) //now shut up eslint

  function ListTable({ list, loader }) {
    return (
      <MaterialReactTable
        state={{ isLoading: loader }}
        columns={columns}
        data={list}
        enableColumnActions={true}
        enableColumnFilters={true}
        enablePagination={true}
        enableSorting={true}
        enableBottomToolbar={true}
        enableTopToolbar={true}
        muiTableBodyRowProps={{ hover: false }}
        displayColumnDefOptions={{
          'mrt-row-numbers': {
            size: 10,
          },
          'mrt-row-expand': {
            size: 10,
          },
        }}
        enableColumnFilterModes
        initialState={{
          columnVisibility: { description: false },
          density: 'compact',
          showGlobalFilter: true,
        }}
        muiSearchTextFieldProps={{
          placeholder: t("search"),
          sx: { minWidth: '18rem' },
          variant: 'outlined',
        }}

        filterFns={{
          myCustomFilterFn: (row, id, filterValue) => {
            const value = row.getValue(id);
            return typeof value === 'string' && value.toLowerCase().includes(filterValue.toLowerCase());
          },
        }}
        globalFilterFn="myCustomFilterFn"

        localization={
          lang === "fr"
            ? MRT_Localization_FR
            : MRT_Localization_EN
        }
      />
    );
  }
  return (
    <>
      <Container fluid>
        <div className="rna-container">
          <NotificationAlert ref={notificationAlertRef} />
        </div>
        <Row>
          <Col md="12">
            <Button
              id="saveBL"
              className="btn-wd btn-outline mr-1 float-left"
              type="button"
              variant="info"
              onClick={ajouter}
            >
              <span className="btn-label">
                <i className="fas fa-plus"></i>
              </span>
              Ajouter un ligne
            </Button>
          </Col>
          <Col md="12">

            <Card>
              <Card.Header>
                <Card.Title as="h4">Liste des lignes</Card.Title>
              
              </Card.Header>
              <Card.Body className="table-style">
           

                  <ListTable list={entities} loader={loader} ></ListTable>


              </Card.Body>
            </Card>
          </Col>


        </Row>
      </Container>
    </>
  );
}

export default ListLigneIms;
